<template>
  <div>
    <DataTableReportMatchData :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable"
               slot-name="second-last-column">
        <span slot="after-filters">
            <v-tooltip bottom>
                <v-btn slot="activator" icon @click="downloadExcel" flat>
                    <v-icon color="primary">far fa-file-excel</v-icon>
                </v-btn>
                <span>Descargar XLS</span>
            </v-tooltip>
        </span>
         <template slot="second-last-column" slot-scope="props">
        <template >
          <td class="text-xs-center table-row" :key="'row-1'">
            {{cutCadena( props.item.observacion )}}
          </td>
        </template>
         <template >
          <td class="text-xs-center table-row " :key="'row-2'">{{  props.item.incumplimiento}}</td>
        </template>
         <template >
          <td class="text-xs-center table-row " :key="'row-3'">{{  props.item.sanction}}</td>
        </template>

      </template>
    </DataTableReportMatchData>
  </div>
</template>

<script>
import DataTableReportMatchData from '../../../common/ui/DataTableReportMatchData'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'

export default {
  mixins: [downloadFileMixin, paginationMixin],

  components: {
    DataTableReportMatchData
  },

  data () {
    return {
      headers: [
        { text: 'Codigo', align: 'left', value: 'codigo', sortable: false },
        { text: 'Torneo', align: 'left', value: 'tournament', filterField: false },
        { text: 'Fecha', value: 'fecha', filterField: false },
        { text: 'Local', align: 'left', value: 'clubLocal', filterField: false },
        { text: 'Visitante', align: 'left', value: 'clubVisitor', filterField: false },
        { text: 'Goles Local', align: 'left', value: 'golesLocal', filterField: false },
        { text: 'Goles Visitante', align: 'left', value: 'golesVisitor', filterField: false },
        { text: 'Penales Local', align: 'left', value: 'penalesLocal', filterField: false },
        { text: 'Penales Visitante', align: 'left', value: 'penalesVisitor', filterField: false },
        { text: 'Dia y Hora', value: 'horario', filterField: false },
        { text: 'Seccion', value: 'section', sortable: false },
        { text: 'Campo', value: 'campo', sortable: false },
        { text: 'Respuesta', align: 'left', value: 'value', filterField: false },
        { text: 'Escala', value: 'escala', sortable: false },
        { text: 'Escala valor', value: 'escalaValue', sortable: false },
        { text: 'Observacion', value: 'observacion', filterField: false },
        { text: 'Estado DP', value: 'incumplimiento', filterField: false },
        { text: 'Estado Final', value: 'sanction', filterField: false }
      ],
      properties: [ 'codigo',
        'tournament',
        'fecha',
        'clubLocal',
        'clubVisitor',
        'golesLocal',
        'golesVisitor',
        'penalesLocal',
        'penalesVisitor',
        'horario',
        'section',
        'campo',
        'value',
        'escala',
        'escalaValue'
      ],
      path: 'reporte-match-data',
      filterPath: 'filters/Informes-auditorias-partido'
    }
  },

  methods: {
    getExcelPath () {
      return 'reporte-match-data/xls' + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return 'informes_match_data'
    },
    cutCadena (txt) {
      return txt.substring(0, 50) + ' ...'
    }
  }
}

</script>

<style scoped>
    .table-row {
        background-color: white;
        border-bottom: 1px solid #959ba6;
    }
    .table-row-no-contracts {
        background-color: #d0caca;
        border-bottom: 1px solid #959ba6;
    }

    .v-chip-custom{
      min-width: 85px;
      padding-left: 20px;
    }
</style>
